import Vue from 'vue'
import Vuex from 'vuex'
import baseInfo from './module/baseInfo'
import chartInfo from './module/chart'
import getters from './module/getters'


Vue.use(Vuex)



export default () => {
  const store = new Vuex.Store({
    modules: {
      baseInfo,
      chartInfo
    },
    getters
  //  strict: process.env.DEV
  })

  return store
}
